import PaymentFormProvider from './PaymentFormProvider';

export default PaymentFormProvider;
